import getHostFlags from "../../utils/getHostFlags";
import ReportTypeFields from "./ReportTypeFields";

const { isAmazon, isDevOrRoovee } = getHostFlags();

const ReportType = {
  seasonReport: ReportTypeFields.seasonReport,
  monthlyReport: ReportTypeFields.monthlyReport,
  dayByDayAccountingReport: ReportTypeFields.dayByDayAccountingReport,
  rentalByRentalAccountingReport:
    ReportTypeFields.rentalByRentalAccountingReport,
  monthlyAccountingReport: ReportTypeFields.monthlyAccountingReport,
  customReportFromTemplate: ReportTypeFields.customReportFromTemplate,
  userFundsAvailableToWithdraw: ReportTypeFields.userFundsAvailableToWithdraw,
  specialDepositWithdrawalReport:
    ReportTypeFields.specialDepositWithdrawalReport,
  userBikeLeftInZoneBonusReport: ReportTypeFields.userBikeLeftInZoneBonusReport,
  complaintsReport: ReportTypeFields.complaintsReport,
  ridersReport: ReportTypeFields.ridersReport,
  debtCollectionReport: ReportTypeFields.debtCollectionReport,
  totalDistanceByUserReport: ReportTypeFields.totalDistanceByUserReport,
  serviceSummaryReport: ReportTypeFields.serviceSummaryReport,
  bikesInSystemReport: ReportTypeFields.bikesInSystemReport,
  monthlyBikesReport: ReportTypeFields.monthlyBikesReport,
  yearlyBikesReport: ReportTypeFields.yearlyBikesReport,
  stationPopularityReport: ReportTypeFields.stationPopularityReport,
  hourlyRentalsReport: ReportTypeFields.hourlyRentalsReport,
  hourlyRentalDurationReport: ReportTypeFields.hourlyRentalDurationReport,
  stationConnectionsReport: ReportTypeFields.stationConnectionsReport,
  bikeDefectsReport: ReportTypeFields.bikeDefectsReport,
  clientFundsReport: ReportTypeFields.clientFundsReport,
  rentalDurationByTypeReport: ReportTypeFields.rentalDurationByTypeReport,
  dailyReport: ReportTypeFields.dailyReport,
  braMonthlyAccountingReport: ReportTypeFields.braMonthlyAccountingReport,
  braPeriodicFinancialReport: ReportTypeFields.braPeriodicFinancialReport,
  adjustmentReport: ReportTypeFields.adjustmentReport,

  ...(isAmazon
    ? {
        specialReport1: ReportTypeFields.specialReport1,
      }
    : {}),
  ...(isDevOrRoovee
    ? {
        specialGlobalReport: ReportTypeFields.specialGlobalReport,
        specialMonthlyAccountingReport:
          ReportTypeFields.specialMonthlyAccountingReport,
        specialGlobalReportUserDebit:
          ReportTypeFields.specialGlobalReportUserDebit,
        globalUserAvailableFundsDepositReport:
          ReportTypeFields.globalUserAvailableFundsDepositReport,
        tenantUserDebitReport: ReportTypeFields.tenantUserDebitReportPerTenant,
        sportCardExpiredAmount: ReportTypeFields.sportCardExpiredAmount,
        medicoverStatisticReport: ReportTypeFields.medicoverStatisticReport,
        medicoverWithdrawalReport: ReportTypeFields.medicoverWithdrawalReport,
        globalDebtCollectionReport: ReportTypeFields.globalDebtCollectionReport,
      }
    : {
        tenantUserDebitReport: ReportTypeFields.tenantUserDebitReportDefault,
      }),
};

export default ReportType;
